export default {
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'google-drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook',
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/video-sources.js